import React, { useState, useEffect } from 'react';
import SlideoutLayout from '../../../layout/slideout/SlideoutLayout';
import { toast } from 'react-toastify';
import AnnouncementForm from '../components/AnnouncementForm';
import { useForm } from 'react-hook-form';
import { CurrentDateForDatePicker } from '../../../../util/formatter';
import { useTranslation } from 'react-i18next';
import {
  getAnnouncementById,
  saveAnnouncement,
} from '../../../../api/announcementApi';

interface AnnouncementEditState {
  message?: string;
  announcementDate?: string;
  expiryDate?: string;
  id?: string;
  [key: string]: unknown;
}

export interface EditProps {
  done: (d?: AnnouncementEditState) => void;
  id?: string;
  cancel: () => void;
}

function Edit({ done, id, cancel }: EditProps) {
  const { t } = useTranslation();
  const {
    register,
    formState: { errors },
    handleSubmit,
    control,
  } = useForm();

  const [announcement, setAnnouncement] = useState<AnnouncementEditState>({
    announcementDate: CurrentDateForDatePicker(),
    expiryDate: CurrentDateForDatePicker(),
  });

  const onSubmit = (data: AnnouncementEditState) => {
    const payload = { ...announcement, ...data };
    saveAnnouncement(payload as any)
      .then(() => {
        toast.success(t('Announcement saved'));
        done(announcement);
      })
      .catch((ex: { message?: string }) => {
        toast.error(ex.message ?? t('Failed to save announcement'));
      });
  };

  useEffect(() => {
    if (id) {
      getAnnouncementById(id).then((d: any) => {
        setAnnouncement(d);
      });
    }
  }, [id]);

  return (
    <SlideoutLayout
      title={`${id ? t('Edit announcement') : t('Add announcement')}`}
      cancel={cancel}
      done={done}
      bar={
        <input
          type="submit"
          value={t('Save')}
          className="btn btn-primary"
          onClick={handleSubmit(onSubmit)}
        />
      }
    >
      <AnnouncementForm
        announcement={announcement}
        register={register}
        errors={errors}
        control={control}
      ></AnnouncementForm>
    </SlideoutLayout>
  );
}

export default Edit;
